import React, {useState} from "react"

import {FieldTableCellProps} from "../../../../../../render/table/table-cell"
import FieldMessagesTotal_TableCellCalculated_Hovered from "./hovered"
import FieldMessagesTotal_TableCellCalculated_NotHovered from "./not-hovered"

// const debug = "FieldMessagesTotal_TableCellCalculated"
const debug = false

export default function FieldMessagesTotal_TableCellCalculated(props: FieldTableCellProps) {

    const [isHovered, setIsHovered]     = useState(false)

    const onMouseEnter = () => {
        if (!props.column.usesSumAggregation) {
            return
        }

        setIsHovered(true)
    }

    const onMouseLeave = () => {
        setIsHovered(false)
    }

    const width = props.column.width

    const style : style = _.clone(props.style) || {} // we need clone here because we add width!
    style.width = width

    debug && console.log(debug, "render() isHovered=", isHovered)

    if (isHovered) {
        return (
            <FieldMessagesTotal_TableCellCalculated_Hovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    } else {
        return (
            <FieldMessagesTotal_TableCellCalculated_NotHovered
                style           = {style}
                field           = {props.field}
                listItem        = {props.listItem}
                column          = {props.column}
                onMouseEnter    = {onMouseEnter}
                onMouseLeave    = {onMouseLeave}
            />
        )
    }
}
